import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
// REDUX
import { connect } from "react-redux";

const AuthenticatedRoute = ({
  component: Component,
  authenticated,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      authenticated ? <Redirect to="/" /> : <Component {...props} />
    }
  />
);

AuthenticatedRoute.propTypes = {
  user: PropTypes.object
};

const mapStateToProps = state => ({
  authenticated: state.user.authenticated
});

export default connect(mapStateToProps)(AuthenticatedRoute);
